import { EditIcon } from 'lucide-react'

import { Skeleton } from '@/components/ui'
import {
  CaseEditButton,
  caseSummaryText,
  resolveCaseHeadline,
  useCaseAccountTypes,
  useCaseConfigIsLoading,
  useCaseTypes,
  useFetchCaseConfig,
  useProject,
} from '@/modules/projects'

// The whole case on one line, and the way into editing it. The Actions menu has
// the same entry; this one sits where the reader already is.
export const CaseSummaryLine = () => {
  const project = useProject()
  useFetchCaseConfig()
  const isLoading = useCaseConfigIsLoading()
  const caseTypes = useCaseTypes()
  const accountTypes = useCaseAccountTypes()

  if (!project) return null
  if (isLoading) return <Skeleton className="mt-2 h-6 w-56" />

  const summary = caseSummaryText(
    resolveCaseHeadline(project, { caseTypes, accountTypes }),
  )

  return (
    <CaseEditButton className="mt-2 cursor-pointer rounded-sm text-sm font-medium text-blue-6 hover:underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring inline-flex gap-2 items-center">
      {summary} <EditIcon className="h-4 w-4" />
    </CaseEditButton>
  )
}
